import { Tooltip } from 'antd'
import { useTranslation } from 'react-i18next'

import { LogoutIcon } from '@icons'
import { RoleEnum } from '@types'
import { useLogout } from '@hooks'
import { useUser } from '@contexts'

import { LoginInfoContainer, LogoutContainer, UserContainer } from '../DashboardLayout/components'

interface UserInfoProps {
  onLogout?: () => void
}

const UserInfo = ({ onLogout }: UserInfoProps) => {
  const { t } = useTranslation()
  const { logout } = useLogout()
  const { state: user } = useUser()
  const roles = user?.roles.map(role => role.name)
  const { PROCUREMENT, ADMIN } = RoleEnum
  const handleLogout = () => {
    if (onLogout) onLogout()
    logout()
  }

  return (
    <UserContainer>
      <LoginInfoContainer>
        <h4>{user?.userDetail.name || <i>{t('globals.login.no_name')}</i>}</h4>
        {user?.userDetail.carrier?.id && (
          <p>{user?.userDetail.carrier?.businessName || <i>{t('globals.login.no_email')}</i>}</p>
        )}
        {user?.userDetail.supplier?.id && (
          <p>{user?.userDetail.supplier?.businessName || <i>{t('globals.login.no_email')}</i>}</p>
        )}
        {user?.roles[0].name === 'ADMINRO' && (
          <p>{user?.roles[0].description || <i>{t('globals.login.no_email')}</i>}</p>
        )}
        {(roles?.includes(PROCUREMENT) || roles?.includes(ADMIN)) && (
          <p>
            {t(`globals.generics.${roles[0].toLowerCase()}`) || (
              <i>{t('globals.login.no_email')}</i>
            )}
          </p>
        )}
      </LoginInfoContainer>
      <LogoutContainer>
        <Tooltip title={t('layout_dashboard.logout')}>
          <LogoutIcon onClick={handleLogout} />
        </Tooltip>
      </LogoutContainer>
    </UserContainer>
  )
}

export default UserInfo
